// Step.js
import React from 'react'
import styled from 'styled-components'
import { FaArrowRight } from 'react-icons/fa'

const Container = styled.div``

const StepContainer = styled.div`
  display: flex;
  flex-direction: ${({ third }) => (third ? 'column' : 'row')};
  align-items: center;
`

const StepLabel = styled.div`
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  padding: 10px;
  margin: 10px;
  border-radius: 5px;
  min-height: 120px;
  width: 100%;
  text-align: center;
  position: relative;
`

const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
`

const Arrow = styled(FaArrowRight)`
  margin-left: 5px;
`

const ArrowDown = styled(FaArrowRight)`
  margin-left: 5px;
  transform: rotate(90deg);
`

const StepContent = styled.div`
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 5px;
  max-width: 300px;
  width: 100%;
  text-align: center;

  color: ${({ clienteNovo }) => (clienteNovo ? 'green' : 'red')};
`

function Step({ label, content, nextStep, third = false, secondLine = false }) {
  return (
    <Container>
      <StepContainer third={third}>
        <StepLabel>
          {label}
          <StepContent clienteNovo>
            <p>{content}</p>
          </StepContent>
        </StepLabel>

        {!secondLine && !third && nextStep && (
          <ArrowWrapper>
            <Arrow />
          </ArrowWrapper>
        )}

        {third && (
          <ArrowWrapper>
            <ArrowDown />
          </ArrowWrapper>
        )}

        {secondLine && nextStep && (
          <ArrowWrapper>
            <Arrow style={{ transform: 'rotate(180deg)' }} />
          </ArrowWrapper>
        )}
      </StepContainer>
    </Container>
  )
}

export default Step
